export function maskDate(date: string | number | Date, type=1, isDoubleDigit=false) {
    const dateObj = new Date(date);

    if (isNaN(dateObj.getTime())) {
        return "";
    }

    const year = dateObj.getFullYear();
    const month = !isDoubleDigit ? (dateObj.getMonth() + 1).toString() : (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = !isDoubleDigit ? dateObj.getDate().toString() : dateObj.getDate().toString().padStart(2, "0");

    if(type == 2){
        return `${year}/${month}/${day}`;
    }
    else if(type == 3){
        return `${year}年 ${month}月`;
    }
    else{
        return `${year}年 ${month}月 ${day}日`;
    }
}

export default maskDate;